// deno-lint-ignore-file require-await
import { bytesToHex } from "@noble/hashes/utils";
import { finalizeEvent, getPublicKey, nip04, nip44 } from "nostr-tools";
/**
 * NIP-07-compatible signer with secret key. It is a drop-in replacement for `window.nostr`.
 *
 * Usage:
 *
 * ```ts
 * const signer = new NSecSigner(secretKey);
 * const pubkey = await signer.getPublicKey();
 * const event = await signer.signEvent({ kind: 1, content: 'Hello, world!', tags: [], created_at: 0 });
 * ```
 */ export class NSecSigner {
  #secretKey;
  constructor(secretKey){
    this.#secretKey = secretKey;
  }
  async getPublicKey() {
    return getPublicKey(this.#secretKey);
  }
  async signEvent(event) {
    return finalizeEvent(event, this.#secretKey);
  }
  nip04 = {
    encrypt: async (pubkey, plaintext)=>{
      return nip04.encrypt(this.#secretKey, pubkey, plaintext);
    },
    decrypt: async (pubkey, ciphertext)=>{
      return nip04.decrypt(this.#secretKey, pubkey, ciphertext);
    }
  };
  #getConversationKey(pubkey) {
    const seckey = bytesToHex(this.#secretKey);
    return nip44.v2.utils.getConversationKey(seckey, pubkey);
  }
  nip44 = {
    encrypt: async (pubkey, plaintext)=>{
      const conversationKey = this.#getConversationKey(pubkey);
      return nip44.v2.encrypt(plaintext, conversationKey);
    },
    decrypt: async (pubkey, ciphertext)=>{
      const conversationKey = this.#getConversationKey(pubkey);
      return nip44.v2.decrypt(ciphertext, conversationKey);
    }
  };
}
//# sourceMappingURL=NSecSigner.js.map